import { FromSchema } from '@40seas/entities/common';
import { z } from 'zod';

export const MoveCheckoutSchema = z.object({
    buyerId: z.string().regex(/^[0-9a-f]{24}$/i),
    sellerId: z.string().regex(/^[0-9a-f]{24}$/i),
    tenantId: z.string().min(1),
});

export class MoveCheckoutDto extends FromSchema(MoveCheckoutSchema) {
    buyerId: string;
    sellerId: string;
    tenantId: string;
}
